"use strict";
Object.defineProperty(exports, "__esModule", { value: true });



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/event-bus/ICC/ICCEventBusInterface.js
// module id = 1187
// module chunks = 8